export default __webpack_public_path__ + "static/media/forbes.177e625d.svg";